import { Dialog, DialogContent, DialogTrigger } from '@/_components/ui/dialog'
import { PlusIcon } from 'lucide-react'
import { useState } from 'react'
import { Button } from '../../../_components/ui/button'
import { CreateFacilityDialog } from './create-facility-dialog'

export interface CreateFacilityButtonProps {
  companyId: string
}

export const CreateFacilityButton = ({ companyId }: CreateFacilityButtonProps) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  return (
    <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
      <DialogTrigger asChild>
        <Button size="xs" className="flex items-center gap-1 font-bold text-brand-grayscale-1">
          <PlusIcon size={16} />
          Nova unidade
        </Button>
      </DialogTrigger>
      <DialogContent className="max-h-[90dvh] max-w-[640px] overflow-y-auto p-5">
        <CreateFacilityDialog companyId={companyId} setIsDialogOpen={setIsDialogOpen} />
      </DialogContent>
    </Dialog>
  )
}
